import { buildExportDataFromAllPages } from "./gridExportAllRecords";
import { mapTeamUserExportRecord } from "./teamUsersTable";
import { fetchAllPagesFromPaginatedEndpoint } from "./teamUsersBackend";

export const TEAM_MEMBER_EXPORT_HEADERS = [
  "Name",
  "Title",
  "Email",
  "Active Status",
  "Role",
  "Portal Access",
  "Created",
];

export const SPONSOR_USER_EXPORT_HEADERS = [
  "Name",
  "Organization",
  "Title",
  "Email",
  "Active Status",
  "Role",
  "Portal Access",
  "Created",
];

export const VENDOR_USER_EXPORT_HEADERS = [
  "Name",
  "Organization",
  "Title",
  "Email",
  "Active Status",
  "Role",
  "Portal Access",
  "VQQ Contact",
  "Assessment Contact",
  "Created",
];

export function buildTeamUsersExportData({
  headers,
  fetchPage,
  mapOptions = {},
}) {
  return buildExportDataFromAllPages({
    headers,
    fetchAllPages: () => fetchAllPagesFromPaginatedEndpoint(fetchPage),
    mapRecord: (item) => mapTeamUserExportRecord(item, mapOptions),
  });
}

export function withVendorContactExportHeaders(isVendorContext, baseHeaders = TEAM_MEMBER_EXPORT_HEADERS) {
  if (!isVendorContext) return baseHeaders;
  const createdIndex = baseHeaders.indexOf("Created");
  if (createdIndex === -1) {
    return [...baseHeaders, "VQQ Contact", "Assessment Contact"];
  }
  return [
    ...baseHeaders.slice(0, createdIndex),
    "VQQ Contact",
    "Assessment Contact",
    ...baseHeaders.slice(createdIndex),
  ];
}
